import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { GroupService } from "src/app/_services/group.service";
import { EditGroup, EditGroupError, EditGroupSuccess, SetEditGroup, SetEditGroupError, SetEditGroupSuccess } from "./edit-group.actions";
import { catchError, map, switchMap } from "rxjs/operators";
import { Group, GroupEditResult } from "src/app/_models/Group";
import { of } from "rxjs";

@Injectable()
export class EditGroupEffects {
  
  constructor(
    private groupService: GroupService,
    private actions$: Actions
  ){}

  public editGroupEffect$ = createEffect(() => 
    this.actions$.pipe(
      ofType(EditGroup),
      switchMap((payload) => {
        return this.groupService.editGroup$(payload.dto.id, payload.dto).pipe(
          map((group: GroupEditResult) => {
            return EditGroupSuccess({group: group});
          }),
          catchError((error) => {
            return of(EditGroupError({error: error}));
          })
        )
      })
    )
  );

  public setEditGroupEffect$ = createEffect(() => 
    this.actions$.pipe(
      ofType(SetEditGroup),
      switchMap((payload) => {
        return this.groupService.getGroup$(payload.groupId).pipe(
          map((group: Group) => {
            return SetEditGroupSuccess({group: {
              groupId: group.id,
              groupName: group.name,
              organisationName: group.organisationName,
              centreName: group.centreName,
              learnerCount: 0, tutorCount: 0
            }});
          }),
          catchError((error) => {
            return of(SetEditGroupError({error: error}));
          })
        )
      })
    )
  );
}